// src/data/AwarenessProjectsData.js

export const awarenessProjects = [
  {
    id: 'proj1',
    name: 'Community Cleanup Drive',
    description: 'Organizing volunteers to clean up local parks and riversides.',
    startDate: '2025-04-20',
    endDate: '2025-04-22',
    status: 'Completed',
    lead: 'Environmental Youth Alliance',
  },
  {
    id: 'proj2',
    name: 'School Recycling Program',
    description: 'Implementing new recycling bins and educational workshops in schools.',
    startDate: '2025-03-01',
    endDate: '2025-12-31',
    status: 'Ongoing',
    lead: 'Green Schools Network',
  },
  {
    id: 'proj3',
    name: 'Urban Greening Initiative',
    description: 'Planting trees and creating small green spaces in urban areas.',
    startDate: '2025-05-10',
    endDate: '2025-11-30',
    status: 'Ongoing',
    lead: 'City Parks Department',
  },
  {
    id: 'proj4',
    name: 'Plastic Bottle Collection Campaign',
    description: 'A city-wide campaign to collect and recycle plastic bottles, focusing on reduction.',
    startDate: '2025-06-01',
    endDate: '2025-08-31',
    status: 'Upcoming',
    lead: 'Save Our Oceans Coalition',
  },
  {
    id: 'proj5',
    name: 'Water Conservation Awareness',
    description: 'Public awareness campaign on efficient water usage and rainwater harvesting.',
    startDate: '2025-07-15',
    endDate: '2025-09-15',
    status: 'Upcoming',
    lead: 'Water Resource Management',
  },
];